<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <template>
                  <div>
                    <v-alert
                      color="#ce3479c7"
                      dark
                      icon="campaign"
                      border="right"
                    >
                      Aún quedan REGISTRO DE COMPRA(s) por cerrar. <br>
                      Número de registros faltante por cerrar a la Fecha de Hoy {{ getNowDate() }} es de <b>{{ numberUnclosedOrders }}</b>
                    </v-alert>
                  </div>
                </template>
              </v-col>

              <v-btn
                color="primary"
                @click="processSalesClosure"
              >
                Cerrar ventas
              </v-btn>

              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>GANANCIA DE VENTAS REALIZADAS</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                            >
                              <template v-slot:item.created_at="{ item }">
                                {{ formatDate(item.created_at) }}
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>

          <v-btn
            fab
            bottom
            right
            color="green"
            dark
            fixed
            @click="domwloadExcel()"
          >
            <v-icon>description</v-icon>
          </v-btn>
        </div>
      </template>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{ text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'OrderProfitView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        panel: [0],
        search: '',
        numberUnclosedOrders: 0,
        headers: [
          { text: 'ID COMPRA', value: 'order_id'},
          { text: 'TIPO DELIVERY', value: 'delivery_type' },
          { text: 'DISTRITO', value: 'district'},
          { text: 'PRECIO DELIVERY', value: 'shipping_price' },
          { text: 'GANANCIA DE PRODUCTOS', value: 'profit' },
          { text: 'FECHA CREACIÓN BALANCE', value: 'created_at' },
        ],
        items: [],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      getNowDate: function() {
        return moment().format("DD/MM/yyyy HH:mm:ss");
      },

      formatDate: function(date) {
        return moment(date).format("DD/MM/yyyy HH:mm:ss");
      },

      getProfits() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.GET_ORDER_PROFIT)
        .then(response => {
          this.items = response.data.orderProfit;
          this.numberUnclosedOrders = response.data.numberUnclosedOrders;
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      domwloadExcel() {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.DOMWLOAD_ORDER_PROFIT, {
          responseType: 'blob',
          headers: {
            'Content-Type': 'text/xls'
          }
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      processSalesClosure() {
        this.overlay = true;
        axios.post(process.env.DINO.PATH.CLOSE_ORDERS)
        .then(response => {
          this.showMessage('Se ejecutó el cierre de los registros faltantes.', 'green');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.getProfits();
          this.overlay = false;
        });
      },
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getProfits();
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/order/OrderProfit.vue